import PaymentSuccessPage from './PaymentSuccessPage'

export default PaymentSuccessPage
